import Echo from "laravel-echo";
import Cookies from "js-cookie";
import { useEffect } from "react";
import { API_WEB_PATH, WEB } from "../constant";
import { useSelector } from "react-redux";

const initializeEcho = () => {
  window.Pusher = require("pusher-js");

  return new Echo({
    broadcaster: "pusher",
    key: process.env.REACT_APP_PUSHER_KEY,
    cluster: "mt1",
    encrypted: false,
    wsPort: 2053,
    wssPort: 2053,
    wsHost: "websocket.91url.cc",
    wssHost: "websocket.91url.cc",
    forceTLS: false,
    disabledStats: true,
    auth: {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${Cookies.get("token")}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  });
};
export const useChannelListener = (channelName, eventName, callback) => {
  const memberInfo = useSelector((state) => state.isMemberInfo);
  useEffect(() => {
    if (Cookies.get("token") !== undefined && memberInfo?.uid !== undefined) {
      const echo = initializeEcho();
      const channel = echo.channel(`${channelName}.${memberInfo?.uid}`);
      channel.listen(eventName, callback);
      // // Cleanup function
      return () => {
        channel.stopListening(eventName);
        echo.leave(`${channelName}.${memberInfo?.uid}`);
        echo.disconnect();
      };
    }
  }, [channelName, eventName, callback, memberInfo?.uid]);
};
